import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { Row } from 'components/UI/Row';

const IosAppStoreLink = styled.a<{ iosStoreLocale: string }>`
  display: inline-block;
  overflow: hidden;
  background: url(https://linkmaker.itunes.apple.com/${({ iosStoreLocale }) => iosStoreLocale}/badge-lrg.svg?releaseDate=2020-03-05&kind=iossoftware&bubble=ios_apps)
    no-repeat;
  width: 135px;
  height: 40px;
`;

const AppStoreLinks = () => {
  const { t } = useTranslation();
  const androidPlayImage = t('_.google play store image');
  const androidPlayAlt = t('_.google play store image alt');
  const iosStoreLocale = t('_.app store locale');
  return (
    <>
      <Row justifyContent="center" margin="32px 0 16px">
        <Typography variant="h6">{t('preview.download app')}</Typography>
      </Row>
      <Row justifyContent="center">
        <IosAppStoreLink
          target="_blank"
          rel="noopener noreferrer"
          href="https://apps.apple.com/app/box-e/id1462591045?mt=8"
          iosStoreLocale={iosStoreLocale}
        />
      </Row>
      <Row justifyContent="center">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://play.google.com/store/apps/details?id=io.fourboxes.boxe&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
        >
          <img
            alt={androidPlayAlt}
            src={`https://play.google.com/intl/en_us/badges/static/images/badges/${androidPlayImage}.png`}
            width={155}
          />
        </a>
      </Row>
    </>
  );
};

export { AppStoreLinks };
